import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<label>{{@question.question}}</label>\n<p class=\"optional multi-line\">{{@answer.freeTextAnswer}}</p>\n")